import { render } from "./AuthorityDetail.vue?vue&type=template&id=159786b2"
import script from "./AuthorityDetail.vue?vue&type=script&lang=js"
export * from "./AuthorityDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__